import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { Pricing } from './NewHome';

/**
 * Mundalo - standalone /pricing page (iter 119).
 *
 * Reuses the exact homepage Pricing section so the cards/copy stay in
 * lock-step. Adds the dedicated meta title + description requested by
 * the founder and wraps the section in the public Header + Footer so
 * the page reads as a first-class route, not a fragment.
 */
const PricingPage = () => (
  <div className="min-h-screen bg-[#F9F6EF]" data-testid="pricing-page">
    <SEO
      title="Mundalo Pricing - Plans for Every Stage of Your Move"
      description="One-time Blueprint plans from $199. Monthly community from $9.99. Pay once to plan the move, pay monthly to live the life."
      path="/pricing"
    />
    <Header currentPage="pricing" />
    <main className="pt-10 md:pt-16">
      <Pricing />
    </main>
    <Footer />
  </div>
);

export default PricingPage;
